/* 
  Format constants
*/

export const FORMAT_KEY = 'Format';
